<div class="modal-header">
    <span class="modal-header-title"> Загрузка из хранилища</span>
    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <span aria-hidden="true"><i class="bi bi-x-lg" style="font-size: 16px;"></i></span>
    </button> -->
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>

<div class="modal-body">

    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
        
        <div class="row">

            <div class="col-12">
                <div class="form-group">
                    <div class="form-group">
                        <label class="filter-label" for="category"> Список файлов</label>
                        <ng-select id="category"
                         class="custom" 
                         placeholder="Выберите из списка"
                         clearAllText="{{ 'CLEAR' | translate }}"
                         notFoundText="{{ 'NO_DATA' | translate }}" 
                         bindLabel="name" 
                         formControlName="file"
                         [multiple]="false" 
                         [closeOnSelect]="true"
                         [items]="files"
                         appendTo="body">
                            <!-- <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                let-index="index">
                                <input id="item-{{index}}" type="checkbox"
                                    [checked]="item$.selected" />&nbsp;
                                <span>{{item.name}}</span>
                            </ng-template> -->
                        </ng-select>
                    </div>
                </div>
            </div>   

        </div>
    </form>
</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-light btn-sm btn-custom-actions" (click)="activeModal.dismiss(false)">
        {{ 'CLOSE' | translate}}
    </button>
    <button  type="button" class="btn btn-primary btn-sm btn-custom-actions" (click)="sendData()" [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
</div>